import { HttpError, request } from '@helpers/general'
import { getRegionZone } from '@helpers/geo-location'
import { useQuery, useQueryClient } from 'react-query'

/**
 * Fetches You May Also Like data based on given skus
 * @param {object} product Product object.
 * @param {string} strSkus string containing a list of skus concatenated by ','. Eg: "7200049P,73001388"
 * @returns {any[]} Product array
 */
const useGetYMALItems = (product, strSkus) => {
  const queryClient = useQueryClient()

  return useQuery({
    queryKey: ['you-may-also-like', product, strSkus],
    queryFn: () => getYMALItems(product, strSkus),
    refetchOnWindowFocus: false,
  })
}

const getYMALItems = async (product, strSkus) => {
  const query = strSkus || (product?.delivery_type !== 'T' && product?.sku)
  const { region: myRegion } = getRegionZone()

  if (query) {
    const options = {
      query,
      categories: false,
      properties: false,
    }
    const URL = `${process.env.GATSBY_RECOMMENDATION_SERVICE}/youMayAlsoLike/${options.query}?division=${myRegion}`

    let data
    await request(URL)
      .then(json => {
        data = json
        return data
      })
      .catch(error => error)
    return data
  }
  return query
}
export default useGetYMALItems
